import {Component, OnInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {InformationLightDto, InformationService} from '../../_services/configuration-services';
import {filter, Subscription, take} from 'rxjs';
import {TranslateUtils} from '../../_shared/translate-utils';
import {faPen} from '@fortawesome/free-solid-svg-icons';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {PermissionKeys} from '../../app.constants';
import {BackofficePermissionsService} from '../../_shared/backoffice-permissions.service';
import {RolesService} from '../../_shared/roles-service';
import {CustomDateFormatter} from '../../_shared/custom-date-formatter';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-informations',
    templateUrl: './informations.component.html',
    styleUrls: ['./informations.component.scss'],
    providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateFormatter }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InformationsComponent implements OnInit, OnDestroy {

    PermissionKeys = PermissionKeys;

    informationArray: InformationLightDto[] = [];

    icons = {
        pen: faPen
    };

    private langChangeSubscription: Subscription;
    crtLang = TranslateUtils.defaultLanguage;

    constructor(private readonly router: Router,
                private readonly route: ActivatedRoute,
                private readonly informationService: InformationService,
                private readonly translateService: TranslateService,
                private readonly backofficePermissionsService: BackofficePermissionsService,
                private readonly rolesService: RolesService,
    ) {}

    ngOnInit(): void {
        this.crtLang = this.translateService.currentLang;
        this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.crtLang = event.lang;
        });

        this.fetchInformations();
    }

    ngOnDestroy(): void {
        this.langChangeSubscription.unsubscribe();
    }

    private fetchInformations(): void {
        // Client account: no backoffice permissions are ever loaded → fetch the self list directly.
        if (!this.rolesService.isBackofficeAccount()) {
            this.loadInformations(false);
            return;
        }
        // Backoffice: wait until permissions are loaded before branching, otherwise a direct page
        // reload reads them as empty and wrongly falls back to the (empty) self list.
        this.backofficePermissionsService.permissionsLoaded$
            .pipe(filter(loaded => loaded), take(1))
            .subscribe(() => this.loadInformations(
                this.backofficePermissionsService.hasPermission(PermissionKeys.gestionCommunication)));
    }

    private loadInformations(canManage: boolean): void {
        const request = canManage ? this.informationService.getAll() : this.informationService.getAllActive();
        request.pipe().subscribe(infoArray => {
            this.informationArray = infoArray;
        });
    }

    readInformation(id: string): void {
        this.router.navigate([id], {
            relativeTo: this.route
        });
    }
}
